<template>
  <JoszakiModal
    :open="isModalOpen"
    class="AttachAnswerModal"
    :title="$t('questionPage.attachAnswerModal.title')"
    @close="closeModal"
    @confirm="attachAnswer"
  >
    <template #body>
      <p>{{ $t("questionPage.attachAnswerModal.info") }}</p>
      <MultiselectList
        v-model="answerToAttach"
        class="answer-selector"
        :options="similarAnswers"
        :placeholder="$t('questionPage.attachAnswerModal.placeholder')"
        track-by="body"
        label="body"
        @search-change="findSimilar"
      >
        <template #noOptions>
          {{ $t("questionPage.attachAnswerModal.noOptions") }}
        </template>
        <template #noResult>
          {{ $t("questionPage.attachAnswerModal.noResults") }}
        </template>
        <template #option="props">
          {{ props.option.body }}
        </template>
      </MultiselectList>
    </template>
    <template #footer>
      <div class="flex flex-1 justify-between">
        <JoszakiButton type="error" @click="closeModal">
          {{ $t("common.cancel") }}
        </JoszakiButton>
        <JoszakiButton
          type="success"
          icon-left="paperclip"
          :disabled="!answerToAttach?.id"
          @click="attachAnswer"
        >
          {{ $t("questionPage.attachAnswerModal.submitButton") }}
        </JoszakiButton>
      </div>
    </template>
  </JoszakiModal>
</template>

<script>
import MultiselectList from "vue-multiselect";
import SIMILAR_ANSWERS from "~/graphql/similarAnswers.graphql";
import { useQuestionStore } from "~/stores/question/question";

export default {
  name: "AttachAnswerModal",
  components: {
    MultiselectList,
  },
  setup() {
    return {
      questionStore: useQuestionStore(),
    };
  },
  data: () => {
    return {
      answerToAttach: {},
      similarAnswers: [],
      finalAttachedAnswer: {},
    };
  },
  computed: {
    isModalOpen() {
      return this.questionStore.isModalOpen("attachAnswerModal");
    },
  },
  methods: {
    closeModal() {
      const prevAttachedAnswer =
        this.questionStore.modalOutput("attachAnswerModal")?.answer;
      this.questionStore.closeModal({
        answer: { ...prevAttachedAnswer },
      });
    },
    async findSimilar(body) {
      if (!body) {
        return;
      }
      try {
        const result = await this.$query(SIMILAR_ANSWERS, {
          body,
        });

        this.similarAnswers = result?.similarAnswers ?? [];
      } catch (e) {
        console.error(e);
      }
    },
    attachAnswer() {
      this.questionStore.closeModal({
        answer: {
          ...this.answerToAttach,
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "vue-multiselect/dist/vue-multiselect.min.css";
</style>

<style scoped lang="scss">
// Multiselect styles
.AttachAnswerModal::v-deep {
  .multiselect.similar-select {
    min-height: 0;

    .multiselect__select,
    .multiselect__tags {
      display: none;
    }

    &.focused {
      .multiselect__content-wrapper {
        display: block !important;
        border-color: #efefef;
      }
    }
  }

  .multiselect__content-wrapper {
    position: relative;
  }

  .multiselect__content {
    width: 100%;
  }

  .multiselect__option {
    > span {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .multiselect__option--highlight {
    background: #f3f3f3;
    color: black;

    &.multiselect__option--selected {
      background: #50c0ff;
    }
  }

  .multiselect__option--highlight:after {
    content: "";
    display: none;
  }

  input.multiselect__input {
    font-size: 16px;
    padding-left: 0;
  }

  .multiselect__tags {
    background: #ffffff;
    border: 1px solid #b8b8b8;
    border-radius: 3px;
  }

  .multiselect__input::placeholder,
  ::placeholder,
  .multiselect__placeholder {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 15px;
    color: #b7b7b7;
  }

  .multiselect__select {
    display: none;
  }
}
</style>
